export const commitInfo = { commitNumber: parseInt('4328'), commitHash: '0871c138' };
